import { defineComponent } from "vue";
import InputWrapper from "./component-library19.mjs";
import { useLabeledInput } from "./component-library247.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "radio-input",
  props: {
    label: { default: void 0 },
    labelClass: { default: void 0 },
    id: { default: void 0 },
    errorMessage: { default: void 0 },
    required: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    showLabel: { type: Boolean },
    large: { type: Boolean },
    medium: { type: Boolean },
    idPrefix: { default: void 0 },
    placeholder: { default: void 0 },
    inputClass: { default: void 0 },
    maxlength: { default: void 0 },
    inputProps: { default: void 0 },
    value: { default: void 0 },
    name: { default: void 0 },
    checked: { type: Boolean, default: false },
    val: { default: "" }
  },
  emits: ["input", "focus"],
  setup(__props, { expose, emit: emits }) {
    const props = __props;
    const { inputWrapperProps, onInput, focus } = useLabeledInput(props, emits);
    const onChange = () => {
      emits("input", props.val);
    };
    expose({ focus, onChange, onInput });
    return { __sfc: true, props, emits, inputWrapperProps, onInput, focus, onChange, InputWrapper };
  }
});
export {
  _sfc_main as default
};
